import React, { useEffect } from "react"

import { useNavigate } from "react-router-dom"

import { ToastrHelper } from "@front-shared/helpers/toastr.helper"
import { useScrollFix } from "@front-shared/hooks/scrollFix.hook"

import { AnalyticsEvent } from "../../config/analytics.config"
import { GENERAL_CONFIG } from "../../config/general.config"
import { ROUTES_CONFIG } from "../../config/routes.config"
import { AnalyticsHelper } from "../../helpers/analytics.helper"

export const CalculatorCheckoutFailedComponent: React.FunctionComponent =
    () => {
        useScrollFix()

        const navigate = useNavigate()

        // Show error message and redirect to main page
        // Also record event in analytics
        useEffect(() => {
            AnalyticsHelper.event(AnalyticsEvent.checkoutFailed)

            ToastrHelper.error(
                `Sorry, but we couldn't confirm your payment. Please try again or contact <a href='mailto:${GENERAL_CONFIG.supportEmail}' target='_blank' rel='noopener noreferrer'>${GENERAL_CONFIG.supportEmail}</a> for assistance`,
                GENERAL_CONFIG.extendedToastrTimeout,
            )

            void navigate(
                ROUTES_CONFIG.calculatorUrl +
                    `?${GENERAL_CONFIG.urlSearchParamsKeys.purchase}=1`,
            )
        }, [])

        return null
    }
